// Source: https://github.com/rackt/react-redux/blob/master/src/components/connect.js#L17
export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}
